(() => {
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-zip-photo]');if(!button)return;
  const gallery=button.closest('.towel-gallery'),photo=gallery.querySelector('#ZipPhoto');
  photo.src=button.dataset.zipPhoto;photo.removeAttribute('srcset');photo.alt=button.querySelector('img').alt;
  gallery.querySelectorAll('[data-zip-photo]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 });
 const form=document.querySelector('[data-zip-form]');if(!form)return;
 const review=document.querySelector('[data-zip-review]');
 const validate=()=>form.querySelectorAll('[data-zip-text]').forEach(input=>input.setCustomValidity(!input.value.trim()?'Please fill in this field.':''));
 for(const event of ['input','change'])form.addEventListener(event,()=>{validate();if(review)review.hidden=true;});
 form.addEventListener('submit',event=>{
  validate();if(!form.checkValidity()){event.preventDefault();form.reportValidity();return;}
  if(!form.hasAttribute('data-preview-zip'))return;
  event.preventDefault();review.replaceChildren();
  const add=(tag,text)=>{const el=document.createElement(tag);el.textContent=text;review.append(el);};
  add('h2','Your personalized golf shoe bag');
  const data=new FormData(form);
  for(const [key,value] of data){if(key==='properties[Personalization confirmed]')continue;add('p',key.replace(/^properties\[/,'').replace(/\]$/,'')+': '+value.trim());}
  const price=35.99;
  add('p',price?`Item subtotal: $${(price*Number(data.get('quantity'))).toFixed(2)} USD`:'Price to be confirmed for this size.');
  add('p','Preview only — nothing has been ordered or saved. Shipping and taxes are not included.');
  review.hidden=false;review.focus();
 });
})();
